import { QueryClient } from '@tanstack/react-query'

const reactQueryConfig = {
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
		},
	},
}

export const queryClient = new QueryClient(reactQueryConfig)
